__turbopack_context__.v({
  "avatar": "jfpNIG_avatar",
  "body": "jfpNIG_body",
  "desktop": "jfpNIG_desktop",
  "header": "jfpNIG_header",
  "mobile": "jfpNIG_mobile",
  "root": "jfpNIG_root",
  "tag": "jfpNIG_tag",
  "tags": "jfpNIG_tags",
});
